import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { GridModule } from "src/app/_modules/modules/grid.module";
import { PresetExportComponent } from "./preset-export.component";

@NgModule({
  declarations: [PresetExportComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
    GridModule
  ],
  exports: [PresetExportComponent]
})
export class PresetExportModule {}
